import tripEventsActionCreators, { actionTypes } from './tripEventsActions';

export default tripEventsActionCreators;
export { actionTypes };
